module.exports = __webpack_public_path__ + "static/media/slider_active.cf27f006.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider_active.svg
// module id = 50
// module chunks = 0